import { render, staticRenderFns } from "./CategoriesCheckboxesAction.vue?vue&type=template&id=4a1cc5b8&scoped=true&"
import script from "./CategoriesCheckboxesAction.vue?vue&type=script&lang=js&"
export * from "./CategoriesCheckboxesAction.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesCheckboxesAction.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CategoriesCheckboxesAction.vue?vue&type=style&index=1&id=4a1cc5b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1cc5b8",
  null
  
)

export default component.exports